import React from 'react';
import './PageStyles.css';

const Pool: React.FC = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Pool & Billiards</h1>
      <div className="page-content">
        <p>We have two full-size pool tables available for our guests. Come and challenge your friends or meet someone new!</p>
      </div>
    </div>
  );
};

export default Pool; 